import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import "./Index.vue?vue&type=style&index=0&id=01f4f970&lang=less&scoped=true"

import exportComponent from "D:\\officialWebsite\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f4f970"]])

export default __exports__